import clsx from 'clsx'
import React from 'react'
import Image from 'next/image'

import { Text } from '@wartek-id/text-v1'

import styles from '../styles.module.css'

type SectionProps = {
  children: React.ReactNode
  className?: string
  imgBackground?: string
  title?: string
}

const Section = ({
  children,
  className,
  imgBackground,
  title,
}: SectionProps) => {
  return (
    <section
      className={clsx('py-16 relative even:bg-gray-0 odd:bg-white', className)}
    >
      {imgBackground && (
        <div className="absolute inset-0 overflow-hidden z-0">
          <Image
            src={imgBackground}
            alt="background"
            layout="fill"
            priority
            objectFit="cover"
            objectPosition="center"
            style={{
              filter: 'blur(2px)',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-blue-600/60 to-blue-800/60" />
        </div>
      )}
      <div className={`${styles['container']} relative z-10`}>
        {title && (
          <Text as="h2" className="mb-5 text-center" variant="display-lg">
            {title}
          </Text>
        )}
        {children}
      </div>
    </section>
  )
}

export default Section
